import React from "react";
import SelectorGridContainer from "./SelectorGridContainer";
import SelectorGridList from "./SelectorGridList";

const SelectorGrid = props => {
  const { atoms, config, onAtomSelect, currentSubStepSelectedAtom, getIconImage, checkEnabledLevel } = props;
  return (
    <SelectorGridContainer>
      <SelectorGridList
        checkEnabledLevel={(atom, type) => checkEnabledLevel(atom, type)}
        getIconImage={(alias) => getIconImage(alias)}
        currentSubStepSelectedAtom={currentSubStepSelectedAtom}
        atoms={atoms}
        config={config}
        onAtomSelect={(atom, type) => onAtomSelect(atom, type)}
      />
    </SelectorGridContainer>
  );
};

export default SelectorGrid;
